import {css} from 'styled-components';

export default css`
  #rev-ProductListPage .rev-FilterMenuL2,
  #rev-ProductDetailPage .rev-FilterMenuL2 {
    position: sticky;
    top: 72px;
    margin: 0px 10px;

    & > .header {
      padding: 23px 0px;
      font-size: 1.25rem;

      & > .label {
        display: none;
      }

      &::before {
        content: '產品列表';
        flex: 1;
        font-size: 1.3rem;
      }
    }

    & > .L1 {
      background-color: transparent;
      border-radius: 0px;
      padding: 0px;
      margin-bottom: 0px;
      box-shadow: none;

      & > .header {
        padding: 10px 0;
        border-top: 1px solid #d0d0d0;
        font-size: 1rem;
        color: #000000;
      }

      & > .L1-items {
        border-top: 1px solid #d0d0d0;
        padding-left: 15px;
        overflow: hidden;

        & > .L2 {
          padding: 5px 10px;
        }

        & > .L2 > .header {
          font-size: 0.95rem;
          color: #6f6f6f;
        }

        & > .L2.selected > .header {
          font-size: 0.95rem;
          color: var(--primaryColor);
        }
      }

      &:last-child {
        border-bottom: 1px solid #d0d0d0;
      }
    }
  }

  #rev-ProductListPage {
    & > .content > div > div > div > div > .product-img {
      overflow: hidden;
    }

    & > .content > div > div > div > div > .product-img > img {
      padding: 0px;
      object-fit: cover;
    }
  }

  #rev-CheckoutInfoPage,
  #rev-CheckoutReviewPage {
    & > .container > .main > div > form > div:nth-child(1) {
      & > .content > div:nth-child(2) {
        display: none !important;
      }

      & > .content > div:nth-child(3) {
        display: none !important;
      }
    }

    & > .container > .main > div > form > div:nth-child(3) {
      display: none;
    }
  }

  #rev-AnonymousOrderDetailPage {
    & > .content > div::before {
      content: '歡迎您參與課程！請至頁面下方「訂單資訊」匯款到指定帳戶，回填匯款資訊。';
      color: var(--secondColor);
    }

    & > .content > div > .order-header {
      margin-top: 20px;
    }

    & > .content > div > div:nth-child(5) {
      display: none;
    }

    & > .content > div > div:nth-child(8) {
      display: none;
    }
  }
`;
